import TopBarLayout from "../../components/TopBarLayout";
import ContentLayout from "../../components/ContentLayout";
import Beian from "./beian";
import ArticleLayout from "./articleLayout";
import { getDefaultSiteTitle, useTitle } from "../../utils/hooks";

export default function HomePage() {
  useTitle(getDefaultSiteTitle());
  return (
    <>
      <TopBarLayout type="index" />
      <ContentLayout>
        <ArticleLayout />
        <Beian />
      </ContentLayout>
    </>
  );
}
